import { render, staticRenderFns } from "./BolsteringPrimaryCare.vue?vue&type=template&id=8da74996&"
import script from "./BolsteringPrimaryCare.vue?vue&type=script&lang=js&"
export * from "./BolsteringPrimaryCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports